var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Prints queries to console for easier debugging
 *
 * @category Modifier
 * @returns
 */
export function debug() {
    return {
        klevuModifierId: "debug",
        modifyAfter: (queries) => __awaiter(this, void 0, void 0, function* () {
            console.log(JSON.stringify(queries, undefined, 2));
            return Array.from(queries);
        }),
    };
}
